<template>
  <div class="admin-product-add">
    <h2>{{ route.query.id ? "상품 수정하기" : "상품 등록하기" }}</h2>
    <div class="add-box">
      <h3>최소 구매 등급</h3>
      <div>
        <select v-model="viewMinUserGrade">
          <option value="N1">N1 - 아이언</option>
          <option value="N2">N2 - 브론즈</option>
          <option value="N3">N3 - 실버</option>
          <option value="N4">N4 - 골드</option>
          <option value="N5">N5 - 플래티넘</option>
          <option value="N6">N6 - 에메랄드</option>
          <option value="N7">N7 - 다이아몬드</option>
          <option value="N8">N8 - 마스터</option>
          <option value="N9">N9 - 그랜드마스터</option>
          <option value="N10">N10 - 챌린저</option>
        </select>
      </div>
    </div>
    <div class="add-box">
      <h3>추천 상품 여부</h3>
      <div>
        <input type="checkbox" class="recommend" v-model="isRecommend" />
      </div>
    </div>
    <div class="category-box">
      <h3>카테고리 설정</h3>
      <p>{{ selectedCategory }}</p>
      <div>
        <div>
          <h4>대분류</h4>
          <div>
            <div v-for="(item, index) in category0List" :key="index">
              <input
                :value="item"
                :id="item.categoryId"
                type="radio"
                name="0"
                v-model="category0Select"
                @change="changeCategory0"
              />
              <label :for="item.categoryId">{{ item.categoryName }}</label>
            </div>
          </div>
        </div>
        <div>
          <h4>중분류</h4>
          <div>
            <div v-for="(item, index) in category1List" :key="index">
              <input
                :value="item"
                :id="item.categoryId"
                type="radio"
                name="1"
                v-model="category1Select"
                @change="changeCategory1"
              />
              <label :for="item.categoryId">{{ item.categoryName }}</label>
            </div>
          </div>
        </div>
        <div>
          <h4>소분류</h4>
          <div>
            <div v-for="(item, index) in category2List" :key="index">
              <input
                :value="item"
                :id="item.categoryId"
                type="radio"
                name="2"
                v-model="category2Select"
              />
              <label :for="item.categoryId">{{ item.categoryName }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="add-box">
      <h3>엑셀 정보</h3>
      <div>
        <h4>엑셀 복사 내용</h4>
        <div>
          <input type="text" v-model="excelContent" />
          <div>
            <button @click="generateExcelContent">자동 완성</button>
          </div>
        </div>
      </div>
    </div>
    <div class="add-box">
      <h3>기본 정보</h3>
      <div>
        <h4>상품명</h4>
        <input
          type="text"
          v-model="productName"
          placeholder="예시) 긱베이프 피크 입호흡 전자담배 기기"
        />
      </div>
      <div>
        <h4>상품 상세설명</h4>
        <div>
          <textarea
            type="text"
            v-model="productDetail"
            rows="10"
            placeholder="예시) <img src='https://picsum.photos/600' style='width: 100%;' />"
          ></textarea>
          <div style="display: grid; grid-template-columns: repeat(6, 1fr)">
            <button @click="crawlProduct('medusa')">메두사</button>
            <button @click="crawlProduct('vapetopia')">베이프토피아</button>
            <button @click="crawlProduct('purecloud')">퓨어클라우드</button>
            <button @click="crawlProduct('vapecompany')">베이프컴퍼니</button>
            <button @click="crawlProduct('0vape')">영베이프</button>
            <button @click="crawlProduct('emvape')">이엠베이프</button>
            <button @click="crawlProduct('siasiu')">샤슈베이프</button>
            <button @click="crawlProduct('vanom')">베놈</button>
            <button @click="crawlProduct('cigarman')">시가맨</button>
            <button @click="crawlProduct('bluemong')">블루몽</button>
            <button @click="crawlProduct('airvaper')">에어베이퍼</button>
            <button @click="crawlProduct('beba')">베이프바스켓</button>
            <button @click="crawlProduct('boomboom')">붐붐리퀴드</button>
            <button @click="crawlProduct('dragonvapes')">용트림</button>
            <button @click="crawlProduct('kvape')">케이베이프</button>
            <button @click="crawlProduct('paxvape')">팍스베이프</button>
            <button @click="crawlProduct('manual')">수동</button>
            <button
              @click="openDialog"
              :disabled="productDetailImages.length === 0"
            >
              미리보기
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="add-box">
      <h3>판매 정보</h3>
      <div>
        <h4>소비자가</h4>
        <input
          type="number"
          v-model="productOriginPrice"
          placeholder="예시) 35,000"
        />
        <span>원</span>
      </div>
      <div>
        <h4>카드판매가</h4>
        <input
          type="number"
          v-model="productSellPrice"
          placeholder="예시) 19,800"
        />
        <span>원</span>
      </div>
      <div>
        <h4>매입가</h4>
        <input
          type="number"
          v-model="productBuyPrice"
          placeholder="예시) 9,900"
        />
        <span>원</span>
      </div>
      <div>
        <h4>매입 운송비</h4>
        <input
          type="number"
          v-model="productBuyDeliveryPrice"
          placeholder="예시) 3,000"
        />
        <span>원</span>
      </div>
    </div>
    <div class="option-box">
      <h3>옵션 / 재고 설정</h3>
      <table v-if="optionList.length > 0">
        <thead>
          <tr>
            <th>품목코드</th>
            <th>품목명</th>
            <th>재고</th>
            <th>삭제</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in optionList" :key="index">
            <td>{{ item.optionCode }}</td>
            <td>
              <input type="text" v-model="item.optionName" />
            </td>
            <td>
              <input
                type="number"
                v-model.number="optionList[index].optionStock"
                min="0"
                @input="onOptionStockInput(index)"
              />
              <span>개</span>
            </td>
            <td>
              <button @click="removeOption(index)">
                <Icon size="24" color="#ff0000">
                  <Trash />
                </Icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <button @click="addOption">옵션 추가</button>
    </div>
    <div class="image-box">
      <h3>이미지 정보</h3>
      <div>
        <h4>썸네일 URL</h4>
        <input
          type="text"
          v-model="productThumbnail"
          placeholder="예시) https://picsum.photos/200"
        />
      </div>
    </div>
    <div class="button-box">
      <button @click="addProduct">
        {{ route.query.id ? "상품 수정하기" : "상품 등록하기" }}
      </button>
    </div>
    <dialog ref="dialogRef">
      <header>
        <h2>상품 상세이미지 미리보기</h2>
        <button @click="closeDialog">
          <span class="material-icons-round">close</span>
        </button>
      </header>
      <main>
        <img
          v-for="(image, index) in productDetailImages"
          :key="index"
          :src="image"
        />
      </main>
    </dialog>
  </div>
</template>

<script setup>
import {
  getDocs,
  collection,
  where,
  query,
  doc,
  setDoc,
  Timestamp,
  getDoc,
  updateDoc,
} from "firebase/firestore";
import { onMounted, ref, computed } from "vue";
import { db } from "@/lib/firebase";
import { generateUUIDFromSeed } from "@/lib/utils";
import { uploadImageByUrl } from "@/lib/imgbb";
import router from "@/router";
import { useRoute } from "vue-router";
import { getUserId } from "@/lib/auth";
import { Icon } from "@vicons/utils";
import { Trash } from "@vicons/ionicons5";
import { useBusyLock } from "@/lib/useBusyLock";

const { runLocked } = useBusyLock();

const productOriginData = ref({});
const route = useRoute();

const viewMinUserGrade = ref("N1");
const isRecommend = ref(false);

const excelContent = ref("");
const productName = ref("");
const productDetail = ref("");
const productOriginPrice = ref(0);
const productSellPrice = ref(0);
const productBuyPrice = ref(0);
const productBuyDeliveryPrice = ref(3000);
const dialogRef = ref(null);

const category0List = ref([]);
const category1List = ref([]);
const category2List = ref([]);

const category0Select = ref(null);
const category1Select = ref(null);
const category2Select = ref(null);

const productDetailImages = ref([]);

const selectedCategory = computed(() => {
  if (category0Select.value && category1Select.value && category2Select.value) {
    return `선택한 카테고리: ${category0Select.value.categoryName} > ${category1Select.value.categoryName} > ${category2Select.value.categoryName}`;
  } else if (category0Select.value && category1Select.value) {
    return `선택한 카테고리: ${category0Select.value.categoryName} > ${category1Select.value.categoryName}`;
  } else if (category0Select.value) {
    return `선택한 카테고리: ${category0Select.value.categoryName}`;
  } else {
    return "";
  }
});

const optionList = ref([]);

const productThumbnail = ref("");

const conditionProductAdd = computed(() => {
  return (
    productName.value &&
    typeof productName.value === "string" &&
    productOriginPrice.value > 0 &&
    productSellPrice.value > 0 &&
    productBuyPrice.value > 0 &&
    productBuyDeliveryPrice.value > 0 &&
    category0Select.value &&
    optionList.value.length > 0 &&
    productThumbnail.value
  );
});

const onOptionStockInput = (index) => {
  // 음수 방지, 정수 보정 등 추가 검증 원하면 여기서 처리
  const val = Number(optionList.value[index].optionStock) || 0;
  optionList.value[index].optionStock = Math.max(0, Math.floor(val));
};

const removeOption = (index) => {
  if (!optionList.value[index]) return;

  if (optionList.value.length <= 1) {
    alert("최소 1개 이상의 옵션이 있어야 합니다.");
    return;
  }

  if (confirm(`"${optionList.value[index].optionName}" 옵션을 삭제할까요?`)) {
    optionList.value.splice(index, 1);

    // 리스트 재정렬 (옵션코드 순서 다시 부여)
    optionList.value = optionList.value.map((item, idx) => ({
      ...item,
      optionCode: (idx + 1).toString().padStart(4, "0"),
    }));
  }
};

const generateExcelContent = () => {
  const data = excelContent.value.split(",");
  productName.value = data[0];
  productOriginPrice.value = parseInt(data[1]);
  productSellPrice.value = parseInt(data[2]);
  productBuyPrice.value = parseInt(data[3]);
};

const loadCategory1ByCategory0 = async () => {
  const categoryDatas = await getDocs(
    query(
      collection(db, "category"),
      where("categoryGrade", "==", 1),
      where("categoryParentId", "==", category0Select.value.categoryId)
    )
  );
  category1List.value = categoryDatas.docs.map((doc) => doc.data());
  category2List.value = [];
};

const loadCategory2ByCategory1 = async () => {
  const categoryDatas = await getDocs(
    query(
      collection(db, "category"),
      where("categoryGrade", "==", 2),
      where("categoryParentId", "==", category1Select.value.categoryId)
    )
  );
  category2List.value = categoryDatas.docs.map((doc) => doc.data());
};

const changeCategory0 = () =>
  runLocked(async () => {
    await loadCategory1ByCategory0();
  }).catch(console.error);

const changeCategory1 = () =>
  runLocked(async () => {
    await loadCategory2ByCategory1();
  }).catch(console.error);

const crawlProduct = (buyer) =>
  runLocked(async () => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(productDetail.value, "text/html");

    let thumbnailImage = null;
    let detailImages = [];
    let options = [];

    let replaceUrl = "";
    switch (buyer) {
      case "medusa":
        replaceUrl = "https://medusamall.com";
        thumbnailImage = doc.querySelector("#big_img_box > div > img");
        detailImages = doc.querySelectorAll("#prdDetail > div.cont img");
        options = doc.querySelectorAll(
          "table.xans-element-.xans-product.xans-product-option.xans-record- optgroup > option"
        );
        if (options.length == 0) {
          options = doc.querySelectorAll(
            "table.xans-element-.xans-product.xans-product-option.xans-record- option"
          );
        }
        break;
      case "vapetopia":
        replaceUrl = "";
        thumbnailImage = doc.querySelector(
          "#contents > div.xans-element-.xans-product.xans-product-detail.section > div.detailArea > div.xans-element-.xans-product.xans-product-image.imgArea > div.RW > div.prdImg > div > a > img"
        );
        detailImages = doc.querySelectorAll("#prdDetail img");
        options = doc.querySelectorAll(
          "table.xans-element-.xans-product.xans-product-option.xans-record- optgroup > option"
        );
        if (options.length == 0) {
          options = doc.querySelectorAll(
            "table.xans-element-.xans-product.xans-product-option.xans-record- option"
          );
        }
        break;
      case "purecloud":
        replaceUrl = "";
        thumbnailImage = doc.querySelector("#sit_pvi_big > a > img");
        detailImages = doc.querySelectorAll("#sit_inf_explan img");
        options = doc.querySelectorAll("#it_option_1 option");
        if (options.length == 0) {
          options = doc.querySelectorAll("#it_option_1 > option");
        }
        break;
      case "vapecompany":
        replaceUrl = "https://vapecompany.co.kr";
        thumbnailImage = doc.querySelector(
          "#contents > div.xans-element-.xans-product.xans-product-detail.section > div.detailArea > div.xans-element-.xans-product.xans-product-image.imgArea > div.RW > div.prdImg > div > a > img"
        );
        detailImages = doc.querySelectorAll(
          "#prdDetail > div:nth-child(1) > div img"
        );
        if (detailImages.length == 0) {
          detailImages = doc.querySelectorAll("#prdDetail > div img");
        }
        options = doc.querySelectorAll(
          "table.xans-element-.xans-product.xans-product-option.xans-record- optgroup > option"
        );
        if (options.length == 0) {
          options = doc.querySelectorAll(
            "table.xans-element-.xans-product.xans-product-option.xans-record- option"
          );
        }
        break;
      case "0vape":
        replaceUrl = "";
        thumbnailImage = doc.querySelector(
          "#shopProductImgsMainDiv > div.shopProductImgMainWrapper.type_thumbnails.sequence_0.on > div"
        );
        detailImages = doc.querySelectorAll("div.productDetailSection img");
        options = doc.querySelectorAll(
          "#shopProductContentInfo > div.shopProductOptionListDiv.row.selectOptions.designSettingElement.text-body > div.productOption.custom-select-wrapper > div > div > div.custom-select-box-list-inner > div > div"
        );
        break;
      case "emvape":
        replaceUrl = "";
        thumbnailImage = doc.querySelector(
          "#contents > div.xans-element-.xans-product.xans-product-detail.section > div.detailArea > div.xans-element-.xans-product.xans-product-image.imgArea > div.RW > div.prdImg > div > a > img"
        );
        detailImages = doc.querySelectorAll("#prdDetail img");
        options = doc.querySelectorAll(
          "table.xans-element-.xans-product.xans-product-option.xans-record- optgroup > option"
        );
        if (options.length == 0) {
          options = doc.querySelectorAll(
            "table.xans-element-.xans-product.xans-product-option.xans-record- option"
          );
        }
        break;
      case "siasiu":
        replaceUrl = "";
        thumbnailImage = doc.querySelector("div.thumb-item__main-img > img");
        detailImages = doc.querySelectorAll("#PRODUCT_DETAIL img");
        options = doc.querySelectorAll("div.select optgroup option");
        if (options.length == 0) {
          options = doc.querySelectorAll("div.select option");
        }
        break;
      case "vanom":
        replaceUrl = "";
        thumbnailImage = doc.querySelector("#btn_owl_0 > a > img");
        detailImages = doc.querySelectorAll("#prod_detail_body > p > img");
        options = doc.querySelectorAll(
          "#prod_options > div > div > div.txt_l > label"
        );
        break;
      case "cigarman":
        replaceUrl = "https://cigarman.co.kr/";
        thumbnailImage = doc.querySelector("img.ThumbImage");
        detailImages = doc.querySelectorAll("#prdDetail > div.cont img");
        options = doc.querySelectorAll(
          "table.xans-element-.xans-product.xans-product-option.xans-record- optgroup > option"
        );
        if (options.length == 0) {
          options = doc.querySelectorAll(
            "table.xans-element-.xans-product.xans-product-option.xans-record- option"
          );
        }
        break;
      case "bluemong":
        replaceUrl = "https://blumongvape.com";
        thumbnailImage = doc.querySelector("#prdDetailImg > img");
        detailImages = doc.querySelectorAll("#prdDetail img");
        options = doc.querySelectorAll(
          "#product_option_id1 > optgroup > option"
        );
        if (options.length == 0) {
          options = doc.querySelectorAll("#product_option_id1 > option");
        }
        break;
      case "airvaper":
        replaceUrl = "https://airvaper.com";
        thumbnailImage = doc.querySelector("#contents .thumbnail img");
        detailImages = doc.querySelectorAll("#prdDetail > div.cont img");
        options = doc.querySelectorAll(
          "#product_option_id1 > optgroup > option"
        );
        if (options.length == 0) {
          options = doc.querySelectorAll("#product_option_id1 > option");
        }
        break;
      case "beba":
        replaceUrl = "";
        thumbnailImage = doc.querySelector("#mainImage > img");
        detailImages = doc.querySelectorAll(
          "#detail > div.detail_cont > div img"
        );
        options = doc.querySelectorAll(
          "#frmView > div > div > div.item_detail_list > div > dl > dd > select > optgroup > option"
        );
        if (options.length == 0) {
          options = doc.querySelectorAll(
            "#frmView > div > div > div.item_detail_list > div > dl > dd > select > option"
          );
        }
        break;
      case "boomboom":
        replaceUrl = "https://boomboomliquid.com";
        thumbnailImage = doc.querySelector(
          "#contents > div.xans-element-.xans-product.xans-product-detail > div.detailArea > div.xans-element-.xans-product.xans-product-image.imgArea > div.keyImg > div > a > img"
        );
        detailImages = doc.querySelectorAll("#prdDetail > div > div img");
        options = doc.querySelectorAll(
          "#product_option_id1 > optgroup > option"
        );
        if (options.length == 0) {
          options = doc.querySelectorAll("#product_option_id1 > option");
        }
        break;
      case "dragonvapes":
        replaceUrl = "https://dragonvapes.kr";
        thumbnailImage = doc.querySelector(
          "#contents2 > div.xans-element-.xans-product.xans-product-detail > div.detailArea > div.xans-element-.xans-product.xans-product-image.imgArea > div > div.thumbnail > a > img"
        );
        detailImages = doc.querySelectorAll(
          "#contents2 > div.xans-element-.xans-product.xans-product-detail > div.xans-element-.xans-product.xans-product-additional > div.cont > div.edibot-product-detail > div > img"
        );
        options = doc.querySelectorAll(
          "#product_option_id1 > optgroup > option"
        );
        if (options.length == 0) {
          options = doc.querySelectorAll("#product_option_id1 > option");
        }
        break;
      case "kvape":
        replaceUrl = "https://www.k-vape.co.kr/";
        thumbnailImage = doc.querySelector("#goods_view_img");
        detailImages = doc.querySelectorAll(
          "#glores-B-view-tab-cont1 > div.glores-B-goods-content > p > img"
        );
        break;
      case "paxvape":
        replaceUrl = "";
        thumbnailImage = doc.querySelector("img.ThumbImage");
        detailImages = doc.querySelectorAll("#prdDetail img");
        options = doc.querySelectorAll("#product_option_id1 option");
        if (options.length == 0) {
          options = doc.querySelectorAll(
            "#product_option_id1 > optgroup > option"
          );
        }
        break;
      case "manual":
        replaceUrl = "";
        detailImages = doc.querySelectorAll("img");
        break;
      default:
        replaceUrl = "";
        break;
    }

    // ✅ 썸네일 세팅
    switch (buyer) {
      case "0vape": {
        const backgroundImage = thumbnailImage?.style?.backgroundImage ?? "";
        const match = backgroundImage.match(/url\(["']?(.*?)["']?\)/);
        productThumbnail.value = match ? match[1] : "";
        break;
      }
      case "manual": {
        productThumbnail.value = "";
        break;
      }
      default: {
        productThumbnail.value = (thumbnailImage?.src ?? "").replace(
          window.location.origin,
          replaceUrl
        );
        break;
      }
    }

    // ✅ 디테일 이미지
    productDetailImages.value = Array.from(detailImages).map((img) => {
      switch (buyer) {
        case "vapecompany":
          if (img.getAttribute("ec-data-src")) {
            img.src = replaceUrl + img.getAttribute("ec-data-src");
          }
          break;
        case "0vape":
          if (img.getAttribute("data-src")) {
            img.src = replaceUrl + img.getAttribute("data-src");
          }
          break;
        default:
          break;
      }
      return (img.src ?? "").replace(window.location.origin, replaceUrl);
    });

    // ✅ 옵션 리스트
    optionList.value = [];

    const pushOptions = (texts) => {
      texts.forEach((option, index) => {
        optionList.value.push({
          optionCode: (index + 1).toString().padStart(4, "0"),
          optionName: option,
          optionStock: 0,
        });
      });
    };

    const normalizeOptionText = (text) => {
      text = (text ?? "").replace("[품절]", "").trim();

      const pricePatterns = [];
      text = text.replace(/\(-?\d{1,3}(,\d{3})*원\)/g, (match) => {
        pricePatterns.push(match);
        return `__PRICE${pricePatterns.length - 1}__`;
      });

      text = text.replace(/\([^()]*\)/g, "");

      pricePatterns.forEach((price, idx) => {
        text = text.replace(`__PRICE${idx}__`, price);
      });

      return text.trim();
    };

    if (buyer !== "vanom") {
      const texts = Array.from(options)
        .filter((opt) => {
          if (opt.value === "" || opt.value === "*" || opt.value === "**")
            return false;

          const cleaned = (opt.textContent ?? "").replace("[품절]", "").trim();

          if (cleaned.includes("[")) return false;
          if (cleaned.includes("제조")) return false;

          return true;
        })
        .map((opt) => normalizeOptionText(opt.textContent));

      pushOptions(texts);
    } else {
      const texts = Array.from(options)
        .filter((opt) => {
          const code = opt.getAttribute("data-optcode");
          if (code === "" || code === "*" || code === "**") return false;
          return true;
        })
        .map((opt) => normalizeOptionText(opt.getAttribute("data-title")));

      pushOptions(texts);
    }
  }).catch((error) => {
    // ✅ 에러 로그는 여기서만 처리(선택)
    console.error(error);
  });

const addOption = () => {
  const newOption = {
    optionCode: (optionList.value.length + 1).toString().padStart(4, "0"),
    optionName: "",
    optionStock: 0,
  };
  optionList.value.push(newOption);
};

const openDialog = () => {
  dialogRef.value.showModal();
};

const closeDialog = () => {
  dialogRef.value.close();
};

function isDifferentArrays(arr1, arr2) {
  return (
    arr1.length !== arr2.length || arr1.some((url, idx) => url !== arr2[idx])
  );
}

const addProduct = () =>
  runLocked(async () => {
    // ✅ 조건 체크: 여기서 return 해도 runLocked가 busy 해제함
    if (!conditionProductAdd.value) {
      alert("모든 항목을 채워주세요.");
      return;
    }

    // 공통: 키워드 추출 함수(중복 제거)
    const normalizeText = (txt) => {
      return String(txt ?? "")
        .replace(/[^A-Za-z0-9가-힣]/g, " ")
        .split(" ")
        .map((t) => t.trim())
        .filter((t) => t.length > 0);
    };

    const buildKeywords = () => {
      const searchKeywords = [];
      searchKeywords.push(...normalizeText(productName.value));

      if (Array.isArray(optionList.value)) {
        optionList.value.forEach((opt) => {
          if (opt?.optionName)
            searchKeywords.push(...normalizeText(opt.optionName));
        });
      }

      return [...new Set(searchKeywords)];
    };

    if (route.query.id) {
      // =========================
      // ✅ 상품 수정 로직
      // =========================
      const uuid = route.query.id;
      const updateData = {};

      updateData.viewMinUserGrade = viewMinUserGrade.value;

      // 카테고리 변경 체크
      if (
        category0Select.value?.categoryId !==
          productOriginData.value.productCategory[0] ||
        category1Select.value?.categoryId !==
          productOriginData.value.productCategory[1] ||
        category2Select.value?.categoryId !==
          productOriginData.value.productCategory[2]
      ) {
        updateData.productCategory = [
          category0Select.value?.categoryId,
          category1Select.value?.categoryId,
          category2Select.value?.categoryId,
        ].filter((id) => id != null);
      }

      // 상품명 변경 체크
      if (productName.value !== productOriginData.value.productName) {
        updateData.productName = productName.value;
      }

      // 상세이미지 변경 체크
      const originDetailUrls = (productOriginData.value.productDetailUrl || [])
        .map((detail) => detail.imageOriginUrl)
        .filter(Boolean);

      if (isDifferentArrays(productDetailImages.value, originDetailUrls)) {
        const detailImageURL = await Promise.all(
          Array.from(productDetailImages.value).map(async (item, index) => {
            const data = await uploadImageByUrl("detail", item, uuid, index);
            return { imageOriginUrl: data?.imageOriginUrl };
          })
        );
        updateData.productDetailUrl = detailImageURL;
      }

      // 키워드 / 옵션 / 추천
      updateData.productNameKeywords = buildKeywords();
      updateData.optionList = optionList.value;
      updateData.isRecommend = isRecommend.value;

      // 썸네일 변경 체크
      const thumbnailURL = await uploadImageByUrl(
        "thumbnail",
        productThumbnail.value,
        uuid,
        0
      );
      if (
        productOriginData.value.productThumbnailUrl.originalUrl !==
        thumbnailURL.originalUrl
      ) {
        updateData.productThumbnailUrl = thumbnailURL;
      }

      updateData.updatedAt = Timestamp.fromDate(new Date());

      await updateDoc(doc(db, "product", uuid), updateData);
      alert("상품이 성공적으로 수정되었습니다.");
    } else {
      // =========================
      // ✅ 상품 신규 등록 로직
      // =========================
      const uid = getUserId();
      const uuid = await generateUUIDFromSeed(productName.value);

      const thumbnailURL = await uploadImageByUrl(
        "thumbnail",
        productThumbnail.value,
        uuid,
        0
      );

      const detailImageURL = await Promise.all(
        Array.from(productDetailImages.value).map(async (item, index) => {
          const data = await uploadImageByUrl("detail", item, uuid, index);
          return { imageOriginUrl: data?.imageOriginUrl };
        })
      );

      const category = [
        category0Select.value?.categoryId,
        category1Select.value?.categoryId,
        category2Select.value?.categoryId,
      ].filter((id) => id != null);

      const productData = {
        productId: uuid,
        productName: productName.value,
        productOriginPrice: productOriginPrice.value,
        productBankSellPrice:
          Math.floor((productSellPrice.value * 0.95) / 100) * 100,
        productSellPrice: productSellPrice.value,
        productBuyPrice: productBuyPrice.value,
        productBuyDeliveryPrice: productBuyDeliveryPrice.value,
        productCategory: category,
        optionList: optionList.value,
        productThumbnailUrl: thumbnailURL,
        productDetailUrl: detailImageURL,
        productLikeCount: 0,
        productViewCount: 0,
        productNameKeywords: buildKeywords(),
        createdBy: uid,
        createdAt: Timestamp.fromDate(new Date()),
        updatedAt: Timestamp.fromDate(new Date()),
        viewMinUserGrade: viewMinUserGrade.value,
        isRecommend: isRecommend.value,
        isActive: true,
        purchaseCount: 0,
        popularScore: 0,
      };

      await setDoc(doc(db, "product", uuid), productData);
      alert("상품이 성공적으로 등록되었습니다.");
    }

    router.push("/admin/product/list");
  }).catch((error) => {
    // ✅ 에러 로그는 여기서만(선택)
    console.error("Error adding product:", error);
  });

onMounted(() => {
  runLocked(async () => {
    const categoryDatas = await getDocs(
      query(collection(db, "category"), where("categoryGrade", "==", 0))
    );
    category0List.value = categoryDatas.docs.map((docSnap) => docSnap.data());

    if (!route.query.id) return;

    const productSnap = await getDoc(doc(db, "product", route.query.id));
    if (!productSnap.exists()) {
      alert("상품 정보를 찾을 수 없습니다.");
      return;
    }

    const originData = productSnap.data();
    productOriginData.value = originData;

    // 데이터 가공
    const detailUrls = (originData.productDetailUrl || [])
      .map((detail) => detail.imageOriginUrl)
      .filter(Boolean);

    // 기존 Product Data 매치
    viewMinUserGrade.value = originData.viewMinUserGrade ?? "";
    isRecommend.value = !!originData.isRecommend;

    if (originData.productCategory?.[0]) {
      const category0Snap = await getDoc(
        doc(db, "category", originData.productCategory[0])
      );
      if (category0Snap.exists()) category0Select.value = category0Snap.data();
    }

    if (originData.productCategory?.[1]) {
      const category1Snap = await getDoc(
        doc(db, "category", originData.productCategory[1])
      );
      if (category1Snap.exists()) category1Select.value = category1Snap.data();
    }

    if (originData.productCategory?.[2]) {
      const category2Snap = await getDoc(
        doc(db, "category", originData.productCategory[2])
      );
      if (category2Snap.exists()) category2Select.value = category2Snap.data();
    }

    await loadCategory1ByCategory0();
    await loadCategory2ByCategory1();

    productName.value = originData.productName ?? "";
    productDetailImages.value = detailUrls;

    productOriginPrice.value = originData.productOriginPrice ?? 0;
    productSellPrice.value = originData.productSellPrice ?? 0;
    productBuyPrice.value = originData.productBuyPrice ?? 0;
    productBuyDeliveryPrice.value = originData.productBuyDeliveryPrice ?? 0;
    optionList.value = originData.optionList ?? [];

    productThumbnail.value = originData.productThumbnailUrl?.originalUrl || "";
  }).catch((error) => {
    console.error(error);
  });
});
</script>

<style scoped lang="scss">
.admin-product-add {
  margin-top: 36px;

  > .add-box {
    margin-top: 24px;
    box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    padding: 24px;

    > div {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-top: 16px;

      > h4 {
        width: 160px;
        border-right: 1px solid rgba(0, 0, 0, 0.25);
      }

      > input,
      textarea,
      select {
        flex: 1;
        padding: 8px 12px;
        border: none;
        border-radius: 4px;
        background-color: #efefef;
        font-size: 14px;

        ::placeholder {
          color: rgba(0, 0, 0, 0.6);
        }

        &:focus {
          outline: 2px solid #007bff;
        }
      }

      > input.recommend {
        flex: unset;
        width: 24px;
        height: 24px;
      }

      > span {
        font-size: 14px;
      }

      > div {
        flex: 1;
        > input,
        textarea {
          width: 100%;
          padding: 8px 12px;
          border: none;
          border-radius: 4px;
          background-color: #efefef;
          font-size: 14px;

          ::placeholder {
            color: rgba(0, 0, 0, 0.6);
          }

          &:focus {
            outline: 2px solid #007bff;
          }
        }

        > div {
          margin-top: 8px;
          display: flex;
          align-items: center;
          gap: 8px;

          > button {
            padding: 8px 12px;
            border: none;
            border-radius: 4px;
            background-color: #007bff;
            color: #fff;
            font-size: 14px;
            cursor: pointer;

            &:hover {
              background-color: #0069d9;
            }

            &:disabled {
              cursor: not-allowed;
              background-color: #efefef;
              color: rgba($color: #000000, $alpha: 0.5);
            }
          }
        }
      }
    }
  }

  > .category-box {
    margin-top: 24px;
    box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    padding: 24px;

    > p {
      margin-top: 16px;
      font-size: 14px;
      font-weight: 700;
      color: #007bff;
    }

    > div {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      margin-top: 16px;
      gap: 16px;

      > div {
        > div {
          border: 1px solid rgba(0, 0, 0, 0.25);
          height: 216px;
          border-radius: 8px;
          overflow-y: scroll;
          margin-top: 8px;
          padding: 8px 12px;

          > div {
            > input {
              display: none;
            }

            > label {
              cursor: pointer;
              font-size: 14px;
            }

            > input:checked + label {
              color: #007bff;
              font-weight: 700;
            }
          }
        }
      }
    }
  }

  > .option-box {
    margin-top: 24px;
    box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    padding: 24px;

    > table,
    th,
    td {
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-collapse: collapse;
    }

    > table {
      width: 100%;
      margin-top: 16px;
      display: table;

      > thead {
        background-color: #efefef;
        > tr {
          display: flex;
          > th {
            padding: 8px;
            font-weight: 700;
            font-size: 14px;
          }

          > th:nth-child(1) {
            width: 96px;
          }
          > th:nth-child(2) {
            flex: 1;
          }
          > th:nth-child(3) {
            width: 192px;
          }
          > th:nth-child(4) {
            width: 64px;
          }
        }
      }

      > tbody {
        > tr {
          display: flex;
          align-items: center;
          > td {
            text-align: center;
            padding: 8px;
            font-size: 14px;
            height: 52px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          > td:nth-child(1) {
            width: 96px;
          }
          > td:nth-child(2) {
            flex: 1;
          }
          > td:nth-child(3) {
            width: 192px;
          }
          > td:nth-child(4) {
            width: 64px;
            > button {
              border: none;
              background: none;
              cursor: pointer;
            }
          }

          > td {
            > input {
              width: 100%;
              padding: 8px 12px;
              border: none;
              border-radius: 4px;
              background-color: #efefef;
              font-size: 14px;

              ::placeholder {
                color: rgba(0, 0, 0, 0.6);
              }

              &:focus {
                outline: 2px solid #007bff;
              }
            }

            > span {
              margin-left: 8px;
            }
          }
        }
      }
    }

    > button {
      margin-top: 16px;
      border-radius: 4px;
      padding: 8px 16px;
      background-color: #007bff;
      border: none;
      color: #fff;
      font-weight: 700;
      font-size: 14px;
      cursor: pointer;
    }
  }

  > .image-box {
    margin-top: 24px;
    box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    padding: 24px;

    > div {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-top: 16px;

      > h4 {
        width: 160px;
        border-right: 1px solid rgba(0, 0, 0, 0.25);
      }

      > input {
        flex: 1;
        padding: 8px 12px;
        border: none;
        border-radius: 4px;
        background-color: #efefef;
        font-size: 14px;

        ::placeholder {
          color: rgba(0, 0, 0, 0.6);
        }

        &:focus {
          outline: 2px solid #007bff;
        }
      }
    }
  }

  > .button-box {
    margin-top: 36px;
    display: flex;
    align-items: center;
    justify-content: center;

    > button {
      border-radius: 4px;
      padding: 12px 24px;
      background-color: #007bff;
      border: none;
      color: #fff;
      font-weight: 700;
      font-size: 16px;
      cursor: pointer;
    }
  }

  > dialog {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 8px;
    width: 90%;
    height: 90%;
    max-width: 600px;
    box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.25);

    &::backdrop {
      background: rgba(0, 0, 0, 0.5);
    }

    > header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 16px;
      position: sticky;
      top: 0;
      border-bottom: 1px solid rgba(0, 0, 0, 0.25);
      background: #efefef;

      > h2 {
        font-size: 18px;
      }

      > button {
        border: none;
        border-radius: 4px;
        padding: 4px 8px;
        background-color: #007bff;
        color: #fff;
        font-weight: 700;
        cursor: pointer;

        > span {
          font-size: 16px;
        }
      }
    }

    > main {
      > img {
        width: 100%;
      }
    }
  }
}
</style>
